import { Discount } from '../data.ts'

export function discountedCabinPrice (price: number, discount: Discount | null | undefined): number {
  if (discount == null) {
    return price
  }
  switch (discount.type) {
    case 'amount':
      return Math.max(0, price - discount.amount)
    case 'percentage':
      return price - (price * discount.percentage) / 100
    default:
      return discount satisfies never
  }
}
